<script>
import CardMediaSkeleton from './CardMedia';
import CardAvatarSkeleton from './CardAvatar';
import CardGlossarySkeleton from './CardGlossary';
export default {
  functional: true,
  render (createElement, context) {
    const { type, number, loading, direction, colProps, ...restProps } = context.props || {};
    const directionClasses = direction !== 'vertical'
      ? 'flex-row' : 'flex-lg-column';
    const getCurrentCard = () => {
      switch (type) {
        case 'avatar':
          return CardAvatarSkeleton;
        case 'glossary':
          return CardGlossarySkeleton;
        case 'media':
        default:
          return CardMediaSkeleton;
      }
    };
    if (!loading) {
      return context.children;
    }
    return (
      <div class={`d-flex root flex-wrap ${directionClasses} ${context.data.staticClass}`}>
        {Array.from(Array(number || 3).keys()).map(key => (
          createElement(getCurrentCard(), { props: { loading: true, key, ...restProps } })
        ))}
      </div>
    );
  },
  props: {
    number: {
      type: Number,
      default: 3,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    withoutMedia: {
      type: Boolean,
      default: false,
    },
    isCard: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'image',
    },
    direction: {
      type: String,
      default: 'vertical'
    },
    isTechGuide: {
      type: Boolean,
      default: false,
    },
    isResources: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      default: 0,
    },
    colProps: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>
.root {
  width: 100%;
}
</style>
